import { HttpRequest } from '../../lib/http';
import { API } from './constant';

export const action = ({ popupId }: { popupId: string }) => {
  return HttpRequest({
    method: API.TYPE,
    url: API.URL(popupId),
  });
};
